module.exports = __webpack_public_path__ + "static/media/iFlyThere_portfolio_image.41e61a37.jpg";